export enum LANGUAGE_ABBREVATION {
    de = 'de',
    en = 'en',
}

export const AVAILABLE_LANGUAGES: Array<`${LANGUAGE_ABBREVATION}`> = [LANGUAGE_ABBREVATION.de, LANGUAGE_ABBREVATION.en]